module.exports = {
    item: 'addr_itm list-group-item ',
    focused: 'focused'
}


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/AutocompleteItemTemplate-style.js
 **/